import React, { useEffect, useState } from "react";
import { Modal, Input, List, Flex } from "antd";
import { toast } from "react-toastify";
import apiInstance from "../../../services/apiService";
import ENDPOINTS from "../../../services/endpoint";
import CustomLoader from "../UI/Loader";
import "./StateSelectorModal.scss";
import { customLogger } from "../../../utils/Logger";

interface State {
  id: string;
  value: string;
}

interface StateSelectorModalProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (state: State) => void;
  country: string | undefined;
}

const StateSelectorModal: React.FC<StateSelectorModalProps> = ({
  visible,
  onClose,
  onSelect,
  country,
}) => {
  const [search, setSearch] = useState<string>("");
  const [statesList, setStatesList] = useState<State[]>([]);
  const [loading, setLoading] = useState(false);

  const filteredStates = statesList.filter((state) =>
    state.value.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    if (visible && !country) {
      toast.error("Please select a State first");
      return;
    }

    if (!visible || !country) return;

    const url =
      ENDPOINTS.GET_STATES + `?country=${country === "CA" ? "1" : "2"}`;
    setLoading(true);

    const getStatesByCountry = async () => {
      try {
        const response = await apiInstance.get(url);
        const data = response.data.data;
        setStatesList(data);
        customLogger(response);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    getStatesByCountry();
  }, [country, visible]);

  return (
    <Modal
      title="Select State"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      className="states-modal custom-modal"
    >
      <Input
        className="state-search-input"
        placeholder="Search..."
        onChange={(e) => setSearch(e.target.value)}
        allowClear
      />
      <List
        className="custom-list"
        loading={{
          spinning: loading,
          indicator: (
            <Flex className="h-full w-full" justify="center" align="center">
              <CustomLoader />
            </Flex>
          ),
        }}
        dataSource={filteredStates}
        renderItem={(state) => (
          <List.Item
            key={state.id}
            onClick={() => onSelect(state)}
            style={{
              cursor: "pointer",
              display: "grid",
              gridTemplateColumns: "repeat(3 ,1fr)",
              alignItems: "center",
            }}
          >
            {/* <div className="flag-wrapper"><img src={state.flag}/></div> */}
            <span>{state.value}</span>
            {/* <span>{state.name}</span> */}
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default StateSelectorModal;
